<div class="seperator"></div>
<div class="title" mat-dialog-title>
    Enable Data Studio
    <img class="logo" [src]="data.dataSourceLogo" alt="Data Studio" />
</div>
<div class="gmail-body">
    <div style="text-align: center;">
        <div>Please use the token below to connect Data Studio connector</div>
        <div class="report-email-container">
            <div class="datastudio-token">
                <div>{{ data.userDataStudioToken }}</div>  
                <button mat-icon-button (click)="copyMessageToClipboard(data.userDataStudioToken)">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
        </div>
        <div class="datastudio-template-link">
            <a href="https://datastudio.google.com/data?search=rubii"
                target="_blank" data-cy="datastudio-template-link">
                Click here to redirect to Data Studio connector
            </a>
        </div>
    </div>
</div>
<div class="dialog-footer">
    <div>
    </div>
</div>
